import { render, staticRenderFns } from "./WhatsappContactCardActionDesktop.vue?vue&type=template&id=60684785&scoped=true"
import script from "./WhatsappContactCardActionDesktop.vue?vue&type=script&lang=js"
export * from "./WhatsappContactCardActionDesktop.vue?vue&type=script&lang=js"
import style0 from "./WhatsappContactCardActionDesktop.vue?vue&type=style&index=0&id=60684785&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60684785",
  null
  
)

export default component.exports